// Order of text transformers matters:
//
// - code should go first as it prevents any transformations inside

import { ImageNode, $isImageNode, $createImageNode } from "../nodes/image/ImageNode";
import * as lexical from "lexical";
import { type TextMatchTransformer } from "@lexical/markdown";

export const IMAGE_TRANSFORMER: TextMatchTransformer = {
  dependencies: [ImageNode],
  export: (node: any) => {
    if (!$isImageNode(node)) {
      return null;
    }
    const src = node.getSrc();
    const altText = node.getAltText();
    const imageContent = `![${altText || "image"}](${src})`;
    return imageContent;
  },
  importRegExp: /!(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
  regExp: /!(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
  replace: (textNode: lexical.TextNode, match: RegExpMatchArray) => {
    const [, altText, imageUrl] = match;
    const imageNode = $createImageNode({
      altText: altText || "image",
      src: imageUrl,
    });
    textNode.replace(imageNode);
    return imageNode as any; // expects a textNode, but we return an ImageNode
  },
  trigger: ")",
  type: "text-match",
};
